import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Footer, Header, MobileContainer } from '../../components/layout';
import { AboutSection, HeroSection } from '../../components/sections';

/**
 * Home Page - Main landing page with hero and about sections
 */
const Home = () => {
  const navigate = useNavigate();

  const handleBookShow = () => {
    const scrollContainer = document.querySelector('.overflow-y-auto');
    if (scrollContainer) scrollContainer.scrollTo(0, 0);
    navigate('/enquiry');
  };

  const handleWatchPerformances = () => {
    const scrollContainer = document.querySelector('.overflow-y-auto');
    if (scrollContainer) scrollContainer.scrollTo(0, 0);
    navigate('/videos');
  };

  // Page-specific meta information
  const pageTitle = "Matisa is Live - Singer & Guitarist";
  const pageDescription = "Professional Singer & Guitarist. Book live performances for weddings, corporate events, festivals, and private parties.";

  return (
    <MobileContainer>
      {/* Page Meta Tags - React 19 hoists these to <head> */}
      <title>{pageTitle}</title>
      <meta name="description" content={pageDescription} />
      {/* Open Graph / Social Media Meta Tags */}
      <meta property="og:type" content="website" />
      <meta property="og:url" content="https://matisa.in/" />
      <meta property="og:title" content={pageTitle} />
      <meta property="og:description" content={pageDescription} />
      <meta property="og:image" content="https://matisa.in/hero_main.png" />
      {/* Twitter Card Meta Tags */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={pageTitle} />
      <meta name="twitter:description" content={pageDescription} />
      <meta name="twitter:image" content="https://matisa.in/hero_main.png" />
      
      <Header />
      <main>
        <HeroSection 
          onBookShow={handleBookShow}
          onWatchPerformances={handleWatchPerformances}
        />
        <AboutSection />
      </main>
      <Footer />
    </MobileContainer>
  );
};

export default Home;
